import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $SignatureRequiredContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: ${spacing(80)};
`;
